// extracted by mini-css-extract-plugin
export default {"container":"uf5Tw","thumbnail":"_17ydG","overlay":"_12jO_","button":"_3r1GF","arrow":"_2Tux-","icon":"_1RWE1"};